const config = {
  apiKey: 'AIzaSyAafUSZnry7cZsIcrWv7Q6q1nXYy_Lj_7g',
  authDomain: 'poppy-ai-16252.firebaseapp.com',
  projectId: 'poppy-ai-16252',
  storageBucket: 'poppy-ai-16252.appspot.com',
  messagingSenderId: '789108582822',
  appId: '1:789108582822:web:34e7d1f6e4f8abbd34c767',
};

// // When deployed, there are quotes that need to be stripped
// Object.keys(config).forEach(key => {
//   const configValue = config[key] + '';
//   if (configValue.charAt(0) === '"') {
//     config[key] = configValue.substring(1, configValue.length - 1);
//   }
// });

export default config;
